import { css } from "@emotion/react";

const DropDownListItem = ({ item, _isItemSelected, onItemSelectHandler }) => {
  const _onItemSelectHandler = (item) => {
    onItemSelectHandler(item);
  }

  return (
    <div css={styles.itemContainer} onClick={() => _onItemSelectHandler(item)}>
      <div css={styles.itemHeader}>
        <span>{item?.title}</span>
        <input type="radio" checked={_isItemSelected} onChange={() => {}} css={styles.radioInput} />
        <span css={styles.radioButton}></span>
      </div>
      <div css={styles.itemImageContainer}>
        <img src={item?.image} height={36} />
      </div>
    </div>
  );
}

export default DropDownListItem;

const styles = {
  itemContainer: css`
    border: 1px solid #EEEEEE;
    cursor: pointer;
    border-radius: 8px;
    &:hover {
      border: 1px solid #262626;
      transition: all 0.3s;
    }
  `,
  itemHeader: css`
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 0.5px solid #EEEEEE;
    padding: 10px;
  `,
  radioInput: css`
    display: none;
  `,
  radioButton: css`
    width: 18px;
    height: 18px;
    border: 1.2px solid #000;
    border-radius: 50%;
    display: inline-block;
    position: relative;
    transition: all 0.3s;
    padding: 2px;
    input:checked + & {
      background-color: #fff;
      border-color: #000;
    }
    input:checked + &::after {
      content: '';
      position: absolute;
      top: 50%;
      left: 50%;
      transform:  translate(-50%, -50%);
      width: 10px;
      height: 10px;
      border-radius: 50%;
      background-color: #000;
    }
  `,
  itemImageContainer: css`
    padding: 5px;
    border-radius: 4px;
    border: 0.5px solid #DDE8FE;
    margin: 10px;
    display: table;
    &: img {
      object-fit: contain;
    }
  `
}
